module.exports = __webpack_public_path__ + "static/media/silestone-xm.d3776461.svg";